@if (processRecord.transitionsList?.length) {
  <section class="common-lateral-panel"
    [attr.aria-labelledby]="'process-record-title-' + processRecord.id"
    [ngClass]="{'common-lateral-panel--expand':processRecord.fullScreen}">
    <div class="common-section-title__lp-container">
      <div class="common-section-title__lp-title-icon">
        <i aria-hidden="true" class="lf-icon-track common-icon__lg common-icon__main"></i>
        <h2 class="common-section-title__lp-label-text" [id]="'process-record-title-' + processRecord.id"
          afTranslate="process.summary.history-title"></h2>
      </div>
    </div>
    <div class="common-lateral-panel__body"
      [id]="'process-record-'+processRecord.id"
      [attr.aria-label]="('process.summary.history-title' | afTranslate)">
      <ul class="common-lateral-panel__list-items-gap">
        @for (transition of processRecord.transitionsList | afOrderBy: ['transitionDate']:false ; track $index) {
          <li class="common-stepper__history-container-stepper">
            <div class="common-stepper__history-dot-container" aria-hidden="true">
              <div class="common-badge__block-dot-md" aria-hidden="true">
                <div class="common-badge__dot-xs-main-1000"></div>
              </div>
              <div class="common-divider__vertical-main-400 h-[22px]"></div>
            </div>
            <div class="common-stepper__history-item-container">
              <div class="common-stepper__history-author-tag">
                <span class="common-stepper__history-author-text">{{transition.stateName}}</span>
              </div>
              <div class="common-stepper__history-date-container">
                <time
                  class="common-stepper__history-date-text"
                  [attr.datetime]="transition.transitionDate">
                  {{transition.transitionDate | convertDate:'without-time'}}
                </time>
                <time
                  class="common-stepper__history-date-text"
                  [attr.datetime]="transition.transitionDate">
                  {{transition.transitionDate | convertDate:'only-time'}}
                  <span aria-hidden="true">h</span>
                </time>
              </div>
            </div>
          </li>
        }
      </ul>
    </div>
    @if(processRecord.fullScreen || processRecord.transitionsList?.length > 3){
      <div class="common-lateral-panel__expand-block-right">
        <button type="button" class="common-button__expand-toned"
          [attr.aria-expanded]="processRecord.fullScreen"
          [attr.aria-controls]="'process-record-'+processRecord.id"
          [attr.aria-label]="(processRecord.fullScreen ? 'common.collapse' : 'common.expand') | afTranslate"
          (click)="processRecord.fullScreen = !processRecord.fullScreen">
          <i aria-hidden="true" class=" common-icon__md"
            [ngClass]="processRecord.fullScreen? 'lf-icon-angle-up': 'lf-icon-angle-down'"></i>
          <span class="common-button__expand-label-text"
            [afTranslate]="processRecord.fullScreen?'common.collapse':'common.expand'"></span>
        </button>
      </div>
    }
  </section>
}
